// Package Block
import React, { useState, useEffect, useRef } from "react";
import { Avatar, Badge, Spin } from 'antd';
import { Drawer, Tabs } from "antd";
import { debounce } from 'lodash'; 
import { useSelector, useDispatch, shallowEqual } from "react-redux";

// Custom Component & functions Block
import notifyIcon from "../../../../_assets/logos/notification.gif";
import readnotifyIcon from "../../../../_assets/logos/notification.svg";
import { JobNotificationsDropdown } from "./JobNotificationsDropdown";
import { UserNotificationsDropdown } from "./UserNotificationsDropdown";
import * as actions from "../../../../../app/modules/Dashboard/_redux/dashboard/dashboardActions";


const { TabPane } = Tabs;

export function NotificationsDrawer() {
  const dispatch = useDispatch();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [page, setPage] = useState(1);
  const [isFetchingMore, setIsFetchingMore] = useState(false); 
  const activityLogContainerRef = useRef(null); 
  const { currentState } = useSelector((state) => ({ currentState: state.dashboard }), shallowEqual);
  const { notificationEntities , listLoading} = currentState;

  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
    dispatch(actions.updatedAllNotifications({is_opened:true}))
  };

  useEffect(() => {
      dispatch(actions.fetchNotifications({page_size: 51}));
  }, []);

  const unreadNotification = notificationEntities?.filter(item=> !item?.is_viewed)
  const openedNotifications = notificationEntities?.filter(item => !item?.is_opened)

  const OpenedNotificationNumberLimit = openedNotifications?.length > 99 ? "99+" : openedNotifications?.length
  const UnreadNotificationNumberLimit = unreadNotification?.length > 99 ? "99+" : unreadNotification?.length

  return (
    <>
      <div style={{ padding: "0px 8px" }} onClick={toggleDrawer}>
      <Badge count={openedNotifications && OpenedNotificationNumberLimit } size="large" >
      <Avatar shape="square" src={openedNotifications?.length > 0 ? notifyIcon : readnotifyIcon  } className="notification-avatar"/>
      </Badge>
      </div>
      <Drawer
        title={<div className="custom-drawer-title">Notifications {unreadNotification?.length > 0 && <span className="mark-all-as-read" onClick={()=>{dispatch(actions.updatedAllNotifications({is_viewed:true}))}}>Mark all as read</span>}</div>}
        placement="right"
        closable={false}
        onClose={toggleDrawer}
        visible={drawerVisible}
        width={450}
        className="custom-drawer"
      >
        <Tabs defaultActiveKey="1" onChange={() => { }}>
          <TabPane tab={<span className="custom-tab-title primary-font">User Alerts {unreadNotification?.length > 0 && <span className="notification-badge">{unreadNotification && UnreadNotificationNumberLimit}</span>}</span>} key="1">
        <Spin spinning={listLoading}>
          <UserNotificationsDropdown  notificationEntities={notificationEntities} />
          </Spin>
          </TabPane>
          <TabPane tab={<span className="custom-tab-title primary-font">File Activity</span>} key="2">
            <JobNotificationsDropdown />
          </TabPane>
        </Tabs>
      </Drawer>
    </>
  );
}
